<!-- 压力测试  -->
<template>
  <div class="yaliceshi-layer">
    <div class="ylcs-container">
      <!-- 左侧压力测试区域 -->
      <div class="ylcs-left">
        <!-- 标题栏 -->
        <div class="ylcs-left-title">
          <div class="title-content">压力场景选择</div>
          <!-- 动态装饰点 -->
          <div class="title-dots">
            <div class="dot dot-1"></div>
            <div class="dot dot-2"></div>
            <div class="dot dot-3"></div>
          </div>
        </div>

        <!-- 压力测试列表 -->
        <div class="ylcs-left-content">
          <div class="scenario-card" v-for="(scenario, index) in scenarios" :key="index"
               :class="{ 'chooise': index === activeScenario }" @click="activeScenario = index">
            <div class="scenario-img">
              <img :src="scenario.image" alt="压力场景">
            </div>
            <div class="scenario-content">
              <div class="scenario-header">{{ scenario.title }}</div>
              <div class="scenario-desc">{{ scenario.description }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧建议区域 -->
      <div class="ylcs-right" v-if="status == 1">
        <!-- 实时建议气泡 -->
        <div class="ylcs-right-message" @click="test">
          <div class="message-content">
            开始测试
            <i class="el-icon-thumb"></i>
          </div>
        </div>

        <!-- 机器人图像 -->
        <div class="ylcs-right-image">
          <img src="@/assets/imgs/case/robot.png" alt="AI助手">
        </div>
      </div>

      <div class="ylcs-right2" v-else>
        <div class="result-header">模拟结果：</div>

        <!-- 图表容器 -->
        <div class="chart-container">
          <div ref="resultChart" class="result-chart"></div>
        </div>

        <!-- 结果说明 -->
        <div class="result-description">
          <p>流动性危机模拟压力测试：模拟时长3个月，推荐产品各收益率为：</p>
          <p>1.xxxx-23%振幅30%；2.xxxx-23%振幅30%；3.xxxx-23%振幅30%；</p>
          <p>4.xxxx-23%振幅30%；5.xxxx-23%振幅30%</p>
        </div>

        <!-- 底部按钮 -->
        <button class="build-portfolio-btn" @click="resetScenario">重新选择</button>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="ylcs-bottom">
      <button class="build-portfolio-btn" @click="handleClick">构建投资组合</button>
    </div>

    <div class="dd-inner" v-show="loading">
      <zdyloading style="width: 200px;" ref="zdyloading" :isShowLoading="loading" loadingTxt="模型正在思考中，请稍等...">
      </zdyloading>
    </div>

  </div>
</template>

<script>
import Zdyloading from '@/components/Zdyloading.vue'
export default {
  name: 'yaliceshi',
  components: {
    Zdyloading
  },
  props: {},
  data () {
    return {
      loading: false,
      activeScenario: null,
      status: 1,
      chartInstance: null,
      scenarios: [
        {
          title: '08次贷危机XXXX',
          description: '模拟08次贷危机，相关XXXX相继破产，导致全球股市XXXXXX，汇率急速波动流动性XXXXXX',
          image: require('@/assets/imgs/case/image_313.png')
        },
        {
          title: '18年股债',
          description: '模拟08次贷危机，相关XXXX相继破产，导致全球股市XXXXXX，汇率急速波动流动性XXXXXX',
          image: require('@/assets/imgs/case/image_314.png')
        },
        {
          title: '流动性危机模拟',
          description: '模拟08次贷危机，相关XXXX相继破产，导致全球股市XXXXXX，汇率急速波动流动性XXXXXX',
          image: require('@/assets/imgs/case/image_315.png')
        },
        {
          title: '中美关税极端情景',
          description: '模拟08次贷危机，相关XXXX相继破产，导致全球股市XXXXXX，汇率急速波动流动性XXXXXX',
          image: require('@/assets/imgs/case/image_316.png')
        },
        {
          title: '人民币急速升值',
          description: '模拟08次贷危机，相关XXXX相继破产，导致全球股市XXXXXX，汇率急速波动流动性XXXXXX',
          image: require('@/assets/imgs/case/image_317.png')
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  beforeDestroy () {
    if (this.chartInstance) {
      this.chartInstance.dispose()
      window.removeEventListener('resize', this.handleResize)
    }
  },
  methods: {
    handleClick () {
      this.$emit('next', 'gjtzzh')
    },
    test () {
      if (this.activeScenario === null) {
        this.$alert('请选择压力场景', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      this.loading = true
      setTimeout(() => {
        this.status = 2
        this.$nextTick(() => {
          this.initChart()
        })
        this.loading = false
      }, 2000)


    },
    resetScenario () {
      this.activeScenario = null
      this.status = 1
    },
    initChart () {
      if (!this.$refs.resultChart) return

      // 初始化echarts实例
      this.chartInstance = this.$echarts.init(this.$refs.resultChart)

      // 模拟数据
      const categories = ['测试开始', '第一阶段', '第二阶段', '事件结束']
      const seriesData = [
        {
          name: '天弘余额宝货币基金',
          type: 'line',
          data: [0, 3, 1, -22],
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: { width: 2 }
        },
        {
          name: '招商招钱宝货币A',
          type: 'line',
          data: [0, 2, -3, -25],
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: { width: 2 }
        },
        {
          name: '易方达增利回报债券A',
          type: 'line',
          data: [0, -5, -10, -28],
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: { width: 2 }
        },
        {
          name: '南方宝元债券A',
          type: 'line',
          data: [0, -2, -5, -15],
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: { width: 2 }
        },
        {
          name: '华夏沪深300ETF联接A',
          type: 'line',
          data: [0, -8, -12, -20],
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: { width: 2 }
        }
      ]

      // 配置项
      const option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderColor: 'rgba(21, 73, 243, 0.5)',
          textStyle: { color: '#fff' }
        },
        legend: {
          data: seriesData.map(s => s.name),
          top: 20,
          textStyle: { color: '#b8c4e0' },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 20
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '10%',
          top: 100,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLine: { lineStyle: { color: 'rgba(255, 255, 255, 0.3)' } },
          axisLabel: { color: '#b8c4e0' },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          min: -30,
          max: 30,
          interval: 10,
          axisLine: { lineStyle: { color: 'rgba(255, 255, 255, 0.3)' } },
          axisLabel: { color: '#b8c4e0' },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
              type: 'dashed'
            }
          }
        },
        series: seriesData,
        color: ['#1549F3', '#FF7D00', '#36CBCB', '#FFB700', '#FF4E4E']
      }

      // 设置配置项
      this.chartInstance.setOption(option)

      // 响应式调整
      window.addEventListener('resize', this.handleResize)
    },
    handleResize () {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    }
  }
}
</script>

<style scoped lang="less">
.yaliceshi-layer {
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;

  .ylcs-container {
    flex: 1;
    width: 100%;
    display: flex;
    gap: 40px;
    margin-bottom: 30px;

    // 左侧市场时讯区域
    .ylcs-left {
      flex: 1;
      display: flex;
      flex-direction: column;

      // 标题栏
      .ylcs-left-title {
        position: relative;
        display: flex;
        align-items: center;
        background-image: url('~@/assets/imgs/case/image_310.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        width: 260px;
        height: 85px;
        border-radius: 8px;

        .title-content {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
          margin-left: 50px;
        }

        // 动态装饰点
        .title-dots {
          display: flex;
          gap: 8px;
          margin-left: 15px;

          .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            animation: pulse 2s infinite;

            &.dot-1 {
              background-color: #FFB700;
              animation-delay: 0s;
            }

            &.dot-2 {
              background-color: #36CBCB;
              animation-delay: 0.5s;
            }

            &.dot-3 {
              background-color: #FF7D00;
              animation-delay: 1s;
            }
          }
        }
      }

      // 压力测试列表容器
      .ylcs-left-content {
        flex: 1;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 12px;
        padding: 20px;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(21, 73, 243, 0.2);
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 20px;

        // 压力场景卡片
        .scenario-card {
          display: flex;
          border-radius: 8px;
          padding: 20px;
          background: linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%);
          border: 1px solid rgba(21, 73, 243, 0.2);
          overflow: hidden;
          transition: all 0.3s ease;
          cursor: pointer;
          min-height: 80px;

          .scenario-img {
            width: 121px;
            height: 78px;
            border-radius: 8px;

            img {
              width: 121px;
              height: 78px;
              display: block;
            }
          }

          .scenario-content {
            flex: 1;
            margin-left: 20px;
          }

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(21, 73, 243, 0.3);
            border-color: rgba(21, 73, 243, 0.5);
          }

          .scenario-header {
            font-size: 18px;
            font-weight: bold;
            color: #fff;
            margin-bottom: 10px;
            position: relative;
            z-index: 1;
          }

          .scenario-desc {
            font-size: 14px;
            color: #b8c4e0;
            line-height: 1.5;
            position: relative;
            z-index: 1;
          }
        }

        .chooise {
          background: linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%);
          border: 3px solid rgba(21, 73, 243, 0.5);
        }

        // 自定义滚动条
        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.2);
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(21, 73, 243, 0.5);
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: rgba(21, 73, 243, 0.7);
        }
      }
    }

    // 右侧建议区域
    .ylcs-right {
      // flex: 0 0 400px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;

      // 实时建议气泡
      .ylcs-right-message {
        position: relative;
        background: rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(21, 73, 243, 0.3);
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 20px;
        min-width: 280px;
        backdrop-filter: blur(10px);

        // 气泡下方三角形
        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid rgba(21, 73, 243, 0.3);
        }

        .message-content {

          font-size: 18px;
          color: #fff;
          font-weight: bold;
          text-align: center;
          line-height: 1.5;
          cursor: pointer;
        }
      }

      // 机器人图像
      .ylcs-right-image {
        width: 384px;
        height: 384px;
        margin-top: 20px;
        position: relative;

        // 机器人发光效果
        &::before {
          content: '';
          position: absolute;
          top: -10px;
          left: -10px;
          right: -10px;
          bottom: -10px;
          background: radial-gradient(circle, rgba(54, 203, 203, 0.3) 0%, transparent 70%);
          border-radius: 50%;
          animation: glow 3s infinite;
        }

        img {
          width: 100%;
          height: 100%;
          display: block;
          z-index: 1;
          position: relative;
        }
      }
    }

    // 模拟结果区域
    .ylcs-right2 {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 12px;
      border: 1px solid rgba(21, 73, 243, 0.2);

      .result-header {
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        margin-bottom: 20px;
        align-self: flex-start;
      }

      .chart-container {
        width: 100%;
        height: 400px;
        margin-bottom: 30px;

        .result-chart {
          width: 100%;
          height: 100%;
        }
      }

      .result-description {
        width: 90%;
        background: rgba(0, 0, 0, 0.5);
        padding: 20px;
        border-radius: 8px;
        border: 1px solid rgba(21, 73, 243, 0.2);
        margin-bottom: 20px;

        p {
          margin: 8px 0;
          font-size: 14px;
          color: #b8c4e0;
          line-height: 1.6;
        }
      }
    }
  }

  // 底部按钮区域
  .ylcs-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: auto;
  }

  .build-portfolio-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: #1549F3;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);

    &:hover {
      background: #1549F3;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(21, 73, 243, 0.5);
    }

    &:active {
      transform: translateY(0);
    }
  }

  // 动画效果
  @keyframes pulse {

    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }

    50% {
      opacity: 0.7;
      transform: scale(0.9);
    }
  }

  @keyframes glow {

    0%,
    100% {
      opacity: 0.5;
    }

    50% {
      opacity: 0.8;
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .ylcs-container {
      flex-direction: column;
      gap: 20px;

      .ylcs-right {
        flex: none;
        min-width: auto;
      }

      .ylcs-right2 {
        flex: none;
        min-width: auto;
      }
    }
  }
}

.dd-inner {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 6, 36, 0.6);

  /deep/ .loading-text {
    color: #fff;
  }
}
</style>
